"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePlatform = exports.PlatformProvider = void 0;
var react_1 = __importStar(require("react"));
var CONSTANTS_1 = require("stremio/common/CONSTANTS");
var device_1 = require("./device");
var PlatformContext = (0, react_1.createContext)({});
var PlatformProvider = function (_a) {
    var children = _a.children;
    var openExternal = function (url) {
        try {
            var hostname_1 = new URL(url).hostname;
            var isWhitelisted = CONSTANTS_1.WHITELISTED_HOSTS.some(function (host) { return hostname_1.endsWith(host); });
            var finalUrl = !isWhitelisted ? "https://www.stremio.com/warning#".concat(encodeURIComponent(url)) : url;
            window.open(finalUrl, '_blank');
        }
        catch (e) {
            console.error('Failed to parse external url:', e);
        }
    };
    return (react_1.default.createElement(PlatformContext.Provider, { value: { openExternal: openExternal, name: device_1.name, isMobile: device_1.isMobile } }, children));
};
exports.PlatformProvider = PlatformProvider;
var usePlatform = function () {
    return (0, react_1.useContext)(PlatformContext);
};
exports.usePlatform = usePlatform;
